import React, { Component } from 'react';

export class PatreonEBegging extends React.Component {

	render () {

    return (
      <div className='ad'>

				<div class="CardBoxColumn">
					<div class="CardBox">
						<div class="CardBoxShadow"></div>
						<div class="CardBoxTitleOuter">
							<p class="CardBoxTitle font20">
							<br />Support deckscalibur! <br/> (please) <br /> <br />

							</p>
							<p class="CardBoxTitle CardBoxSubtitle">
							</p>
						</div>
						<div class="CardBoxContainer">

							<div className="CardBoxBackground PatreonBoxBackground" />
							<div className="CardBoxTint" />

							<p class="CardBoxTitle CardBoxText">
								The best things in life are free, but I'm poor, and paying for deckscalibur's server costs is not the best.<br /> <br /> I don't have a programming job yet, so I'd very much appreciate it if you'd spare some change so the site can keep running. Thank you! <br />
							</p>

							<p class="CardBoxTitle CardBoxText">
								<a href="https://www.patreon.com/bePatron?u=20686476" className="patreon"></a>
							</p>

						</div>
					</div>
				</div>
      </div>
    );
  }
}

export default PatreonEBegging;



// WEBPACK FOOTER //
// ./src/Components/PatreonEBegging.js